import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from './canonical.service';

@Injectable({
  providedIn: 'root',
})
export class MetaContentService {
  keyword!: any;
  description!: any;
  Title!: any;
  canonical!: any;
  questionSimpleText: any;
  answerText: any;
  dom: any;
  schemaData: any;

  constructor(
    private meta: Meta,
    private title: Title,
    private canonicalService: CanonicalService,
    @Inject(DOCUMENT) private doc: any
  ) {}

  updateMetaContent(
    keyword: any,
    description: any,
    title: any,
    answertext: any,
    canonical: any,
    pageCategory: any,
    robot?: any,
    schemaData?: any
  ) {
    if (pageCategory == 'forum') {
      this.updateCategoryMetaContent(keyword, description, title, canonical);
    } else if (pageCategory == 'readAnswer') {
      this.updateQuestionMetaContent(title, description, canonical, robot, schemaData);
    } else if (pageCategory == 'cms') {
      this.updateCMSMetaContent(keyword, description, title, canonical, robot, this.doc, null);
    } else if (pageCategory == 'package') {
      this.updatePakageMetaContent(description, title);
    } else if (pageCategory == 'Error') {
      this.UpdateErrorContent(title);
    } else {
    }
  }

  updateCategoryMetaContent(keyword: any, description: any, title: any, canonical: any) {
    this.meta.updateTag({ name: 'description', content: description }, 'name=description'),
      this.meta.updateTag({ name: 'keywords', content: keyword }, 'name=keywords'),
      this.meta.updateTag({ name: 'robots', content: 'index,follow' }, 'name=robots'),
      this.canonicalService.setCanonicalURL(canonical);
    this.canonicalService.setSchema();

    this.title.setTitle(title);
  }
  updateQuestionMetaContent(title: any, description: any, canonical: any, robot?: string, schemaData?: string) {
    this.description = String(description || '').trim();
    this.Title = String(title || 'Question not available').trim();

    this.meta.updateTag({ name: 'description', content: this.description }, 'name=description');
    this.meta.updateTag({ name: 'robots', content: robot || 'noindex,follow' }, 'name=robots');
    this.title.setTitle(this.Title);
    if (canonical) {
      this.canonicalService.setCanonicalURL(canonical);
    } else {
      this.canonicalService.clearCanonicalURL();
    }
    this.canonicalService.setSchema(schemaData);
    this.meta.removeTag('name="keywords"');
  }

  updateCMSMetaContent(
    keyword: any,
    description: any,
    title: any,
    canonical: any,
    robot: any,
    doc: any,
    headerSchema: any
  ) {
    this.description = description;

    if (
      (this.description == null || this.description == undefined || this.description == '') &&
      canonical != 'faqs.aspx'
    ) {
      this.meta.updateTag({ name: 'description', content: '' }, 'name=description'),
        this.meta.updateTag({ name: 'keywords', content: '' }, 'name=keywords'),
        this.meta.updateTag({ name: 'robots', content: '' }, 'name=robots'),
        this.title.setTitle(title);
    } else if (
      (this.description == null || this.description == undefined || this.description == '') &&
      canonical == 'faqs.aspx'
    ) {
      this.meta.updateTag({ name: 'description', content: this.description }, 'name=description'),
        this.meta.updateTag({ name: 'keywords', content: keyword }, 'name=keywords'),
        this.meta.updateTag({ name: 'robots', content: robot }, 'name=robots');

      this.canonicalService.setCanonicalURL(canonical);
      this.title.setTitle(title);
    } else {
      this.meta.updateTag({ name: 'description', content: this.description }, 'name=description'),
        this.meta.updateTag({ name: 'keywords', content: keyword }, 'name=keywords'),
        this.meta.updateTag({ name: 'robots', content: robot }, 'name=robots');

      this.canonicalService.setCanonicalURL(canonical);
      this.title.setTitle(title);

      if (headerSchema && doc?.head) {
        const titleTag = doc.head.querySelector('title');
        if (titleTag) {
          titleTag.insertAdjacentHTML('afterend', '\n' + headerSchema.trim());
        }
      }
    }
  }

  updatePakageMetaContent(description: any, title: any) {
    this.description = description;
    this.meta.updateTag({ name: 'description', content: this.description }, 'name=description');
    this.title.setTitle(title);
  }

  UpdateErrorContent(title: any) {
    this.title.setTitle(title);
    this.meta.updateTag({ name: 'robots', content: 'noindex,follow' }, 'name=robots');
    this.canonicalService.clearCanonicalURL();
    this.canonicalService.setSchema();
  }
}
